/* eslint-disable */
import { FC, useEffect, useLayoutEffect } from 'react';
import { Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import features from '~/constants/features';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import LeftLayout from '~/layouts/LeftLayout';
import WizardContent from '~/layouts/WizardContent';
import { isAgent } from '~/utils/getDecodedJwt';
import CompletionContainer from '~/pages/ksa/completion/components/CompletionContainer';
import { usePageTitle } from '~/context/PageTitleContext';

const ReviewReject: FC = () => {
  const { t } = useTranslation('ksaCompletion');
  const { setPageTitle } = usePageTitle();

  useLayoutEffect(() => {
    setPageTitle(t('Review Rejected'));
    return () => setPageTitle('');
  }, []);

  return (
    // <WizardContent
    //   left={
    //     <LeftLayout>
    //       <BottomLeftActions contactUsUrl={features.contactUsLinkHardDecline} />
    //     </LeftLayout>
    //   }
    //   content={
    <CompletionContainer>
      <Typography.Title>
        {t('We are sorry to say that merchant’s application has not been successful this time')}
      </Typography.Title>
      {isAgent() ? (
        <p>{t('This  application was declined.')}</p>
      ) : (
        <Typography.Paragraph className="Completion-Paragraph">
          <p>
            <Trans t={t} i18nKey="If you wish to discuss with us, please <1>contact us</1>.">
              {'If you wish to discuss with us, please '}
              <a href={features.contactUsLinkHardDecline} target="__blank">
                contact us
              </a>
              .
            </Trans>
          </p>
        </Typography.Paragraph>
      )}
    </CompletionContainer>
    //   }
    //   right={null}
    // />
  );
};

export default ReviewReject;
